/**
 * Returns a persistent guest UUID stored in localStorage.
 * Same guest gets the same ID across sessions for reactions.
 */
export function getGuestId() {
  let id = localStorage.getItem("gve_guest_id");
  if (!id) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `g_${Math.random().toString(36).slice(2)}_${Date.now()}`;
    localStorage.setItem("gve_guest_id", id);
  }
  return id;
}

export const REACTIONS = [
  { key: "heart", label: "Curtir", char: "❤️" },
  { key: "clap", label: "Palmas", char: "👏" },
  { key: "fire", label: "Top", char: "🔥" },
  { key: "laugh", label: "Rindo", char: "😂" },
  { key: "wow", label: "Uau", char: "🤩" },
];
